import { Grid, RadioGroup, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { PhaseModalLine } from './PhaseModalLine';
import { useDispatch, useSelector } from 'react-redux';
import { setUpdatedPhase } from './phasesSlice';

export const PhaseModalContent = () => {
  const selectedPhase = useSelector((state) => state.phases.updatedPhase);
  const dispatch = useDispatch();
  const handlePhaseChange = (event) => {
    if (event.target?.classList[0] === 'PrivateSwitchBase-input') {
      dispatch(setUpdatedPhase(event.target.value));
    }
  };

  return (
    <Box p={3}>
      <RadioGroup
        name={'updatedActivePhase'}
        value={selectedPhase}
        onClick={handlePhaseChange}
      >
        <Grid container gap={1}>
          <Grid size={2}>
            <Typography variant="labelMedium">
              Phase
              <span style={{ marginLeft: '4px' }} aria-label="required field">
                *
              </span>
            </Typography>
          </Grid>
          <Grid size={4.75}>
            <Typography variant="labelMedium">
              Target Completion Date
            </Typography>
          </Grid>
          <Grid size={4.75}>
            <Typography variant="labelMedium">
              Actual Completion Date
            </Typography>
          </Grid>
        </Grid>

        <PhaseModalLine phaseId={1} />
        <PhaseModalLine phaseId={2} />
        <PhaseModalLine phaseId={3} />
        <PhaseModalLine phaseId={4} />
        <PhaseModalLine phaseId={5} />
      </RadioGroup>
    </Box>
  );
};
